function GooglePlayIconSvg({ size = 64 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5234 9.24167C10.9806 9.79001 10.6665 10.6437 10.6665 11.7493V51.1854C10.6665 52.291 10.9806 53.1448 11.5234 53.6931L11.6573 53.8135L34.5547 31.7237V31.2021L11.6573 9.11238L11.5234 9.24167Z"
        fill="url(#gpIconGrad0)"
      />
      <path
        d="M42.1782 39.0898L34.5542 31.7229V31.2013L42.1874 23.8343L42.3583 23.9302L51.3981 28.8942C53.9779 30.303 53.9779 32.6212 51.3981 34.0388L42.3583 38.994L42.1782 39.0898Z"
        fill="url(#gpIconGrad1)"
      />
      <path
        d="M42.3589 38.9944L34.5548 31.4625L11.5234 53.6927C12.3803 54.562 13.7776 54.6668 15.3666 53.7974L42.3589 38.9944"
        fill="url(#gpIconGrad2)"
      />
      <path
        d="M42.3589 23.931L15.3666 9.12796C13.7776 8.26755 12.3803 8.37232 11.5234 9.24164L34.5548 31.4629L42.3589 23.931Z"
        fill="url(#gpIconGrad3)"
      />
      <defs>
        <linearGradient
          id="gpIconGrad0"
          x1="32.5217"
          y1="51.5961"
          x2="2.61368"
          y2="20.6072"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="gpIconGrad1"
          x1="54.7575"
          y1="31.4596"
          x2="10.0493"
          y2="31.4596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="gpIconGrad2"
          x1="38.1153"
          y1="27.368"
          x2="-2.44242"
          y2="-14.6555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="gpIconGrad3"
          x1="5.72597"
          y1="66.8133"
          x2="23.8368"
          y2="48.048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GooglePlayIconSvg;
